<section class="flex flex-col bg-card overflow-hidden height-100p">
  <div class="flex flex-col h-full">
    <div
      class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
      appAccountColorBackground
      #backgroundDirective="appAccountColorBackground"
      [colorName]="panelDef?.color"
    >
      @if (changeTitleMode) {
        <div class="flex items-center flex-auto">
          <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
        </div>
      } @else {
        <div class="flex flex-col">
          <div
            class="font-bold text-md text-secondary uppercase tracking-wider"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          >
            {{ panelDef?.title }}
          </div>
        </div>
      }
      <div class="ml-auto">
        @if (!readonly && !changeTitleMode) {
          <button
            mat-icon-button
            (click)="openAddOfferModal()"
            [matTooltip]="'Add Offer'"
            [appAuthorize]="canEditDeal()"
            denyAction="disable"
          >
            @if (!changeTitleMode) {
              <mat-icon
                [svgIcon]="'add'"
                [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
              ></mat-icon>
            }
          </button>
        }
        @if (!changeTitleMode && canEditPanelDef) {
          <button mat-icon-button type="button" [matMenuTriggerFor]="listCardMenu">
            <mat-icon
              class="icon-size-20"
              [svgIcon]="'more_vert'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
        }
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            @for (color of accountColors$ | async; track color.label) {
              <div mat-menu-item class="gap-2" (click)="selectHeaderColor(color.name)">
                <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
                {{ color.label }}
              </div>
            }
          </mat-menu>
        </mat-menu>
        @if (changeTitleMode) {
          <button
            class="cancel-button"
            mat-icon-button
            type="button"
            [matTooltip]="'Cancel'"
            (click)="toggleEditMode(false)"
          >
            <mat-icon
              [svgIcon]="'cancel'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
          <button mat-icon-button type="submit" [matTooltip]="'Save'" (click)="saveLayout()">
            <mat-icon
              [svgIcon]="'save'"
              [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
            ></mat-icon>
          </button>
        }
      </div>
    </div>

    @if (offersDataSource?.data?.length) {
      @if (canChangeVisibleColumns()) {
        <section class="w-full flex justify-start p-2">
          <button
            mat-icon-button
            (click)="openFieldDefsPanel()"
            #fieldDefsPanelOrigin
            [appAuthorize]="canChangeVisibleColumns()"
          >
            <mat-icon [svgIcon]="'visibility'"></mat-icon>
          </button>
          <ng-template #fieldDefsPanel>
            <div class="contacts-details-tags-panel">
              <div class="mx-2 my-4">
                <div class="flex items-center">
                  <mat-icon [svgIcon]="'search'"></mat-icon>
                  <input
                    class="ml-1"
                    type="text"
                    placeholder="Enter field name"
                    (input)="filterFields($event)"
                    [maxLength]="50"
                  />
                </div>
              </div>

              <div class="available-tags">
                @for (fieldDef of filteredFieldDefs; track fieldDef.name) {
                  <mat-checkbox
                    [color]="'primary'"
                    [checked]="displayColumns.includes(fieldDef.name)"
                    (change)="toggleDisplayColumn(fieldDef.name, $event)"
                  >
                    {{ fieldDef.label }}
                  </mat-checkbox>
                }
              </div>
            </div>
          </ng-template>
        </section>
      }
      <div class="flex flex-col h-full overflow-auto">
        @if (newTable) {
          <ts-table
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [data]="data"
            [actions]="actions"
            (onColumnMove)="onColumnMoved($event)"
            (sortChanged)="onSortChanged($event)"
            (gridReady)="onGridReady($event)"
          ></ts-table>
        } @else {
          <table
            mat-table
            matSort
            [matSortActive]="'offer_type'"
            [matSortDisableClear]="true"
            [matSortDirection]="'asc'"
            [dataSource]="offersDataSource"
            [trackBy]="trackByFn"
            class="w-full bg-transparent table-container"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="dropColumns($event)"
          >
            <ng-container [matColumnDef]="column" *ngFor="let column of displayColumns; index as i">
              @if (lookupField(column); as fieldDef) {
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  cdkDrag
                  cdkDragBoundary=".table-container"
                  cdkDropList
                  cdkDragLockAxis="x"
                  class="border p-0"
                >
                  <div class="p-1 flex items-center" cdkDragHandle>
                    <mat-icon class="cursor-pointer" [svgIcon]="'drag_indicator'"></mat-icon>
                    <p class="pl-1">{{ fieldDef.label }}</p>
                  </div>
                </th>
                <td mat-cell *matCellDef="let offer" class="px-2 border">
                  <span class="whitespace-nowrap">
                    <ng-container [ngSwitch]="column">
                      <ng-container *ngSwitchCase="'workflow_state'">
                        <span
                          class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
                          [ngClass]="{
                            'gray-200': offer.workflow_state === offerWorkflowStateEnum.DRAFT,
                            'blue-200': offer.workflow_state === offerWorkflowStateEnum.SUBMITTED,
                            'red-200': offer.workflow_state === offerWorkflowStateEnum.REJECTED,
                            'green-200': offer.workflow_state === offerWorkflowStateEnum.ACCEPTED,
                          }"
                        >
                          <span
                            class="w-2 h-2 rounded-full mr-1"
                            [ngClass]="{
                              'gray-600': offer.workflow_state === offerWorkflowStateEnum.DRAFT,
                              'blue-600': offer.workflow_state === offerWorkflowStateEnum.SUBMITTED,
                              'red-600': offer.workflow_state === offerWorkflowStateEnum.REJECTED,
                              'green-600': offer.workflow_state === offerWorkflowStateEnum.ACCEPTED,
                            }"
                          ></span>
                          <span class="pr-2px leading-relaxed whitespace-nowrap">{{
                            offer.workflow_state | titlecase
                          }}</span>
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'offer_type'">
                        <p>{{ offer.offer_type | formatSnakeCase }}</p>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <app-editable
                          [fieldDef]="fieldDef"
                          [model]="offer"
                          [readonly]="true"
                          [data]="data"
                        ></app-editable>
                      </ng-container>
                    </ng-container>
                  </span>
                </td>
              }
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr
              class="offer-table-row cursor-pointer"
              mat-row
              *matRowDef="let row; columns: displayColumns"
              (click)="openEditOfferModel(row)"
            ></tr>
          </table>
        }
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center h-full py-8">
        <mat-icon class="icon-size-40" [svgIcon]="'gavel'"></mat-icon>
        <p class="text-2xl text-secondary font-medium mt-4">No Offers</p>
        <p class="text-sm text-secondary mt-2" [appAuthorize]="canEditDeal()">
          Add offers to this panel by clicking in the
          <mat-icon class="icon-size-14" [svgIcon]="'add'"></mat-icon>
          button above.
        </p>
      </div>
    }
  </div>
</section>
